<template>
  <div class="content-wrapper d-md-flex align-items-center justify-content-center">
    <div class="icon-container d-flex justify-content-center align-self-center  me-lg-3">
      <AboutBedIcon v-if="icon === 'bed'"/>
      <AboutDoctorIcon v-if="icon === 'doctor'"/>
      <AboutHeartIcon v-if="icon === 'heart'"/>
      <AboutTechnologyIcon v-if="icon === 'technology'"/>
      <VenousCareIcon v-if="icon === 'care'"/>
      <VenousLegIcon v-if="icon === 'leg'"/>
    </div>
    <div class="title"> {{ title }}</div>
  </div>
</template>

<script>


import AboutBedIcon from "@/components/Common/Icons/AboutBedIcon.vue";
import AboutDoctorIcon from "@/components/Common/Icons/AboutDoctorIcon.vue";
import AboutHeartIcon from "@/components/Common/Icons/AboutHeartIcon.vue";
import AboutTechnologyIcon from "@/components/Common/Icons/AboutTechnologyIcon.vue";
import VenousCareIcon from "@/components/Common/Icons/VenousCareIcon.vue";
import VenousLegIcon from "@/components/Common/Icons/VenousLegIcon.vue";

export default {
  name: 'HighlightIconBox',
  components: {VenousLegIcon, VenousCareIcon, AboutTechnologyIcon, AboutHeartIcon, AboutDoctorIcon, AboutBedIcon},
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
  }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  background: $color-grey;
  border-radius: 30px;
  padding: 30px;
  height: 200px;
  transition: 0.3s ease-in-out;

  &:hover {
    background: $color-light-brown;
  }
}

.title {
  margin-top: $spacing-3;
  font-size: $paragraph-2;
  line-height:  $paragraph-1-lh;
  text-align: center;
}

@media screen and (min-width: 768px) {
  .content-wrapper {
    padding: 50px;
    height: 180px;
  }
  .title {
    margin-top: 0;
    width: 60%;
    text-align: left;
    font-size: $paragraph-1;
  }

}

</style>